var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54 3.066a.5.5 0 0 1 .92 0l1.586 3.684a.5.5 0 0 0 .413.3l3.993.37a.5.5 0 0 1 .284.874l-3.013 2.647a.5.5 0 0 0-.158.486l.882 3.912a.5.5 0 0 1-.743.54l-3.449-2.047a.5.5 0 0 0-.51 0l-3.449 2.047a.5.5 0 0 1-.743-.54l.882-3.912a.5.5 0 0 0-.158-.486L3.264 8.294a.5.5 0 0 1 .284-.873l3.993-.37a.5.5 0 0 0 .413-.3l1.587-3.685Z",
    fill: "currentColor"
  })));
};
export default SvgStarFilled;